import { makeClassDecorator } from './decorators';
export class Scope {
    constructor(name) {
        this.name = name;
    }
    toString() {
        return this.name || '[anonymous provide scope]';
    }
}
/**
 * 可注入类的装饰器
 */
export const Injectable = function InjectableDecorator(options) {
    if (this instanceof InjectableDecorator) {
        this.provideIn = (options === null || options === void 0 ? void 0 : options.provideIn) || null;
    }
    else {
        return makeClassDecorator(Injectable, new Injectable(options));
    }
};
